import { IApplicationState } from '../../../../../../types/types';
import { getHintInitial } from '../../hint/selectors/getHintInitial';
import { THintKey } from '../../../types';
import { IHint } from '../../hint/types';
import { HINTS_INITIAL } from '../../../constants';

export const getHint = (
    state: IApplicationState,
    key: THintKey
): IHint => {
    if (state.hints === HINTS_INITIAL) { // hints not loaded
        return {} as any;
    }

    const hint = state.hints && state.hints[key] || getHintInitial();
    return hint;
}
